import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-comment.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-comment.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Inject, Input } from "@angular/core";
import { APP_BASE_HREF } from "@angular/common";
import { ViewCommentConstants } from "./view-comment.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SaLongDatePipe } from "../../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { AppConfig } from "../../../app.config";
let ViewCommentComponent = class ViewCommentComponent {
    baseHref;
    modalService;
    saLongDatePipe;
    commentId;
    moduleId;
    jobId;
    comment;
    currentStepName;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    businessUnitLabel = ViewCommentConstants.BUSINESS_UNIT_LABEL;
    nameLabel = ViewCommentConstants.NAME_LABEL;
    capturedDateLabel = ViewCommentConstants.CAPTURE_DATE_LABEL;
    capturedByLabel = ViewCommentConstants.CAPTURE_BY_LABEL;
    commentTypeLabel = ViewCommentConstants.COMMENT_TYPE_LABEL;
    emailLabel = ViewCommentConstants.EMAIL_LABEL;
    contactNoLabel = ViewCommentConstants.CONTACTNO_LABEL;
    commentTextLabel = ViewCommentConstants.COMMENT_TEXT_LABEL;
    attachmentsLabel = ViewCommentConstants.ATTACHMENT_LABEL;
    reviewStatusLabel = ViewCommentConstants.REVIEW_STATUS_LABEL;
    reviewNoteLabel = ViewCommentConstants.REVIEW_NOTE_LABEL;
    reviewByUserLabel = ViewCommentConstants.REVIEW_BY_USER_LABEL;
    reviewByDateLabel = ViewCommentConstants.REVIEW_BY_DATE_LABEL;
    businessUnitText;
    nameText;
    capturedDateText;
    capturedByText;
    commentTypeText;
    emailText;
    contactNoText;
    commentText;
    reviewStatusText;
    reviewNoteText;
    reviewByUserText;
    reviewByDateText;
    attachments = [];
    description;
    titleLbl = ViewCommentConstants.TITLE_LBL;
    cancelBtnLbl = SharedConstants.CANCEL_LABEL;
    closeBtnLbl = SharedConstants.CLOSE_LABEL;
    commentNotReviewed = ViewCommentConstants.COMMENT_NOT_REVIEWED;
    isExternalComment = false;
    reviewStatus = null;
    hasReview = false;
    constructor(baseHref, modalService, saLongDatePipe) {
        this.baseHref = baseHref;
        this.modalService = modalService;
        this.saLongDatePipe = saLongDatePipe;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnChanges(changes) {
    }
    ngOnInit() {
        this.initForm();
    }
    initForm() {
        this.businessUnitText = this.comment.businessUnit;
        this.nameText = this.comment.name;
        this.capturedDateText = this.comment.date;
        this.capturedByText = this.comment.capturedBy;
        this.commentTypeText = this.comment.commentType;
        this.emailText = this.comment.email;
        this.contactNoText = this.comment.contactNo;
        this.commentText = this.comment.comment;
        if (this.comment.reviews && this.comment.reviews.length > 0) {
            this.hasReview = true;
            let review = this.comment.reviews[0];
            this.reviewStatus = review.reviewStatus;
            this.reviewStatusText = this.comment.reviewStatus;
            this.reviewNoteText = review.note;
            this.reviewByUserText = `${review.lastReviewedBy.firstName} ${review.lastReviewedBy.lastName}`;
            this.reviewByDateText = this.saLongDatePipe.transform(review.lastReviewDate);
        }
        else {
            this.hasReview = false;
            this.reviewStatusText = this.commentNotReviewed;
        }
        this.attachments = this.comment.links;
        if (this.commentTypeText === "External") {
            this.isExternalComment = true;
        }
    }
    onBtnCloseClicked() {
        this.modalService.close();
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: NgbActiveModal },
        { type: SaLongDatePipe }
    ];
    static propDecorators = {
        commentId: [{ type: Input }],
        moduleId: [{ type: Input }],
        jobId: [{ type: Input }],
        comment: [{ type: Input }],
        currentStepName: [{ type: Input }]
    };
};
ViewCommentComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-comment",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewCommentComponent);
export { ViewCommentComponent };
